import React, { Component } from 'react'
import Icon from 'components/icon/icon'

import ContentEditable from 'react-contenteditable'

export default class EditableInputField extends Component {
    componentWillUpdate = nextProps => {
        if(!this.props.isEditing && nextProps.isEditing){
            setTimeout(_ => {
                if(this.inputRef.htmlEl){
                    this.inputRef.htmlEl.focus()
                }
            },1)
        }
    }

    render(){
        const {
            text, 
            updateText, 
            saveItem, 
            deleteItem, 
            toggleEditing, 
            cancelEditing,
            isEditing, 
            disableEdits,
            openTask,
            hasTask,
            isDisabled,
            canDelete = true
        } = this.props

        return (
            <div className={isEditing ? 'editable-input-field edited' : 'editable-input-field'}>
                <ContentEditable
                    onChange={e => updateText(e.target.value)} 
                    html={text}
                    disabled={!isEditing && true}  
                    onKeyPress={e => {(e.key === 'Enter' ? saveItem() : null)}}
                    ref={ref => this.inputRef = ref}
                />
                { !isDisabled ?
                <ul 
                    onClick={e => {e.stopPropagation()}}
                    className={hasTask ? 'has-task' : null}
                >
                    {
                    !isEditing ? 
                    <div>
                            {
                                !disableEdits ?
                                <li>
                                    <Icon onClick={toggleEditing} name="fe-edit-2" />
                                </li>
                                :
                                <li>
                                    <Icon onClick={openTask} name="fe-eye" />
                                </li>
                            }
                            { canDelete ?
                                <li>
                                    <Icon onClick={deleteItem} name="fe-trash-2" />
                                </li>
                            : null }
                        </div>
                        :
                        <div>
                            <li>
                                <Icon onClick={saveItem} name="check" />
                            </li>
                            <li>
                                <Icon onClick={cancelEditing} name="ban" />
                            </li>
                        </div>
                    }
                </ul>
                : null }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/input/editableInputField.jsx